import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React, { memo, useEffect, useRef, useState } from 'react'
import TableHead from './TableHead'
import TableRow from './TableRow'
import { useDefaultComponentTools } from '../../../../../../hooks/useDefaultComponentTools'


const Table = memo(({titles, positionsIds, currentTab, setPositionInfoId}) => {
	const { theme } = useDefaultComponentTools()
	const ref = useRef()
	const [isScrollBar, setScrollBar] = useState(false)
	useEffect(() => {
		if(!positionsIds.length) return
		setScrollBar(ref.current.scrollHeight !== ref.current.offsetHeight)
	}, [positionsIds])

	return (
		<Box
			sx={{
				border: theme.palette.border,
				borderRadius: '4px',
				display: 'flex',
				flexDirection: 'column',
				height: '100%'
			}}
		>
			{!positionsIds.length  ? null : <TableHead
				headCells={titles}
				isScrollBar={isScrollBar}
			/>}
			{!positionsIds.length ? null : (
				<Box ref={ref}
					sx={{ height: 'calc(100% - 43px)',
						overflow: 'auto'}}
				>
					{positionsIds.map((position, index) => {
						return (
							<TableRow
								setPositionInfoId={setPositionInfoId}
								currentTab={currentTab}
								positionId={position}
								titles={titles}
								key={index * Math.random()}
							/>
						)
					})}
				</Box>
			)}
		</Box>
	)
})

Table.propTypes = {
	currentTab: PropTypes.string,
	positionsIds: PropTypes.array,
	setPositionInfoId: PropTypes.func,
	titles: PropTypes.array
}

Table.displayName = 'AppTable'

export default Table
